import React from 'react';

type BriefcaseRoundIconProps = React.SVGProps<SVGSVGElement>;

export const BriefcaseRoundIcon: React.FC<BriefcaseRoundIconProps> = (props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#F6EFFF" />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9F5FF" strokeWidth="8" />
    <path
      d="M32 37V21C32 20.4696 31.7893 19.9609 31.4142 19.5858C31.0391 19.2107 30.5304 19 30 19H26C25.4696 19 24.9609 19.2107 24.5858 19.5858C24.2107 19.9609 24 20.4696 24 21V37M20 23H36C37.1046 23 38 23.8954 38 25V35C38 36.1046 37.1046 37 36 37H20C18.8954 37 18 36.1046 18 35V25C18 23.8954 18.8954 23 20 23Z"
      stroke="#6941C6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BriefcaseRoundIcon.displayName = 'BriefcaseRoundIcon';

export default BriefcaseRoundIcon;
